import React from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { useAiWidgetConfig } from '../../controllers/ai-widget-config-context';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { AiCornerAgent } from '../ai-corner-agent';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { AiSearchTrigger, AiSearchTriggerFloating } from '../ai-search-trigger';

/**
 * AiSearchTrigger with props from the AiWidgetConfigProvider
 */
export var AiSearchTriggerWithContext = function AiSearchTriggerWithContext() {
  var _useAiWidgetConfig = useAiWidgetConfig(),
    supportWidgetConfig = _useAiWidgetConfig.supportWidgetConfig;
  return /*#__PURE__*/React.createElement(AiSearchTrigger, {
    site: supportWidgetConfig.site,
    siteId: supportWidgetConfig.siteId,
    widgetId: supportWidgetConfig.widgetId,
    widgetTheme: supportWidgetConfig.widgetTheme
  });
};

/**
 * AiSearchTriggerFloating with props from the AiWidgetConfigProvider
 */
export var AiSearchTriggerFloatingWithContext = function AiSearchTriggerFloatingWithContext() {
  var _useAiWidgetConfig2 = useAiWidgetConfig(),
    supportWidgetConfig = _useAiWidgetConfig2.supportWidgetConfig;
  return /*#__PURE__*/React.createElement(AiSearchTriggerFloating, {
    site: supportWidgetConfig.site,
    siteId: supportWidgetConfig.siteId,
    widgetId: supportWidgetConfig.widgetId,
    widgetTheme: supportWidgetConfig.widgetTheme
  });
};

/**
 * AiCornerAgent with props from the AiWidgetConfigProvider
 */
export var AiCornerAgentWithContext = function AiCornerAgentWithContext() {
  var _useAiWidgetConfig3 = useAiWidgetConfig(),
    supportWidgetConfig = _useAiWidgetConfig3.supportWidgetConfig;
  return /*#__PURE__*/React.createElement(AiCornerAgent, {
    site: supportWidgetConfig.site,
    siteId: supportWidgetConfig.siteId,
    widgetId: supportWidgetConfig.widgetId
  });
};